import UserBiometrics from 'models/user/UserBiometrics';
import viewerSocialProfile from 'models/user/ViewerSocialProfile';

let globalUserBiometricsObject;
if (viewerSocialProfile) {
    globalUserBiometricsObject = new UserBiometrics({
        displayName: viewerSocialProfile.getDisplayName()
    });
}

export default globalUserBiometricsObject;
